import { render, staticRenderFns } from "./QuickTipsItem.vue?vue&type=template&id=08888c9b&scoped=true&"
import script from "./QuickTipsItem.vue?vue&type=script&lang=ts&"
export * from "./QuickTipsItem.vue?vue&type=script&lang=ts&"
import style0 from "./QuickTipsItem.vue?vue&type=style&index=0&id=08888c9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08888c9b",
  null
  
)

export default component.exports